import React, { Component } from 'react'
import { StyleLoader } from './style'
export class Loader extends Component {
  render () {
    const { className = '', colorTheme } = this.props

    return (
      <StyleLoader colorTheme={colorTheme}>
        <div className='block' />
        <div className='box-loader'>
          <div className={`loader ${className}`} />
        </div>
      </StyleLoader>
    )
  }
}
